import Vue from 'vue'

export default {
    /**
     * Получение списка логов с пагинацией и фильтрами
     * @param {Object} params - { page, per_page, type, system, is_error, search }
     */
    list(params = {}) {
        return Vue.axios.get('/admin/app-logs', { params })
    },

    /**
     * Получение статистики по логам
     */
    stats() {
        return Vue.axios.get('/admin/app-logs/stats')
    },

    /**
     * Получение одного лога по ID
     * @param {number} id
     */
    get(id) {
        return Vue.axios.get(`/admin/app-logs/${id}`)
    },

    /**
     * Удаление лога по ID
     * @param {number} id
     */
    remove(id) {
        return Vue.axios.delete(`/admin/app-logs/${id}`)
    },

    /**
     * Проверка статуса заказа iiko
     * @param {string} iikoId - UUID заказа из orderInfo.id
     */
    orderStatus(iikoId) {
        return Vue.axios.post('/admin/app-logs/order/status', { iiko_id: iikoId })
    },

    /**
     * Проверка статуса транзакции Glovo
     * @param {string} storeId - ID магазина Glovo
     * @param {string} transactionId - queue_transaction_id из лога
     */
    glovoTransactionStatus(storeId, transactionId) {
        return Vue.axios.post('/admin/app-logs/glovo/transaction/status', { store_id: storeId, transaction_id: transactionId })
    },
}